import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

const VersoLogo = ({ size = 48, animated = false }) => {
  const [currentPart, setCurrentPart] = useState(0);

  useEffect(() => {
    if (!animated) return;

    const interval = setInterval(() => {
      setCurrentPart(prev => (prev + 1) % 3);
    }, 150);

    return () => clearInterval(interval);
  }, [animated]);

  const getOpacity = partIndex => {
    if (!animated) return 1;
    return currentPart === partIndex ? 1 : 0.5;
  };

  return (
    <Box
      sx={{
        width: size,
        height: size,
        position: 'relative',
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Parte 1 - Principal */}
        <path
          d="M50.7467 6.89765C53.9165 6.60048 61.9659 6.11526 69.6158 11.4113L69.6197 11.4143C75.3904 15.3268 78.0433 20.5093 79.1324 22.9797C79.5285 24.1687 79.9011 25.3337 80.274 26.5021C80.519 27.2699 80.7654 28.0388 81.0181 28.8156C77.3271 26.2133 70.1208 22.0038 60.5123 22.0002H60.5133C56.6008 21.8999 50.1474 21.8901 44.2017 26.298C38.0833 30.8123 33.8928 39.1996 35.2428 46.3644L35.3111 46.7043C36.135 50.6156 38.8021 54.7058 42.3795 60.2707L42.3844 60.2775C42.9492 61.1248 43.4662 61.8715 43.897 62.4855C40.1374 62.8146 33.6946 62.7633 28.192 58.7941C23.09 55.1006 20.4371 49.1257 19.7349 42.758C19.0546 36.5873 20.2152 30.1069 22.6988 25.1105L22.9429 24.632C26.278 18.2563 31.6763 14.7154 34.3765 12.9152C37.1724 11.1177 42.679 7.48823 50.7369 6.89863L50.7467 6.89765Z"
          fill="#5EBB9F"
          stroke="#5EBB9F"
          opacity={getOpacity(0)}
          sx={{
            transition: 'opacity 0.25s ease-in-out',
          }}
        />

        {/* Parte 2 */}
        <path
          d="M58.9293 26.6124C63.5024 26.4627 68.0956 27.4909 71.693 28.9581L72.399 29.2579C82.2007 33.7708 86.0386 42.9929 87.6373 46.8898V46.8907C89.0285 50.2695 92.271 58.5342 89.4195 68.5636H89.4185L89.4166 68.5733C88.828 70.8296 86.6649 77.8092 79.8853 83.3116L79.8834 83.3126C72.177 89.6103 63.3446 89.8255 59.3961 89.6202C61.5915 88.3026 64.3374 86.2596 66.8834 83.2208L66.8824 83.2198C72.6697 76.3344 76.4261 65.5895 73.231 55.5177L73.0738 55.0392C72.3871 52.8828 70.2541 46.8534 64.5143 43.3009L63.9469 42.965C59.9739 40.7077 55.8511 40.5906 52.6715 40.7306L51.3805 40.7999C46.7108 40.983 42.9498 42.2382 40.4693 43.3009C40.7871 40.4977 41.9252 35.7708 45.6578 31.9493V31.9483C49.2422 28.2671 54.0542 26.7721 58.9293 26.6124Z"
          fill="#5EBB9F"
          stroke="#5EBB9F"
          opacity={getOpacity(1)}
          sx={{
            transition: 'opacity 0.25s ease-in-out',
          }}
        />

        {/* Parte 3 */}
        <path
          d="M12.5038 37.3367C12.3585 41.1006 12.7564 46.9664 15.7489 53.2156L15.7499 53.2176C17.239 56.2951 22.5313 67.5353 34.4022 69.8895V69.8904C36.4362 70.2972 43.2899 71.426 50.0526 67.4305L50.0536 67.4314C55.0271 64.5089 57.7871 60.1285 59.3017 56.3611C60.3946 53.6424 60.8438 51.2218 61.0106 49.8582C62.943 51.7034 65.985 55.1818 67.0087 60.2937V60.2947C68.1727 66.3088 65.8748 71.595 63.1405 75.4871C60.7485 78.8919 58.053 81.185 57.164 81.8943L56.9032 82.0975C50.5315 86.8028 43.6621 87.2013 40.3847 87.3006H40.371C39.5596 87.3483 35.1406 87.4494 29.6688 85.9549C24.2004 84.4612 17.7062 81.3818 12.6913 75.0887L12.6884 75.0848L12.3925 74.7166C10.6618 72.5277 5.33907 65.1923 5.79872 55.7234C6.09455 50.7144 7.86656 46.2815 8.65712 44.5027L8.66493 44.4832C9.82922 41.5337 11.2377 39.1353 12.5038 37.3367Z"
          fill="#5EBB9F"
          stroke="#5EBB9F"
          opacity={getOpacity(2)}
          sx={{
            transition: 'opacity 0.25s ease-in-out',
          }}
        />
      </svg>
    </Box>
  );
};

export default VersoLogo;
